import * as React from 'react';

export interface OrderPackageVariantProps {
  description: string;
}

export const OrderPackageVariant: React.FC<OrderPackageVariantProps> = ({
  description,
}) => {
  return (
    <div className="flex flex-col items-start gap-1">
      <dt className="text-sm leading-4 text-gray-500">Wariant pakietu</dt>
      <dd className="text-left text-base font-bold text-zinc-800">{description}</dd>
    </div>
  );
};
